import { persistReducer } from "redux-persist";
import storage from "redux-persist/es/storage";
import { createSelector } from "reselect";

import { getDetailsBatch } from "@/api/materials";

const prefix = "favoriteList";

const ADD_FAVORITE = `${prefix}/ADD_FAVORITE`;
const REMOVE_FAVORITE = `${prefix}/REMOVE_FAVORITE`;
const FETCH_STARTED = `${prefix}/FETCH_STARTED`;
const FETCH_FAILED = `${prefix}/FETCH_FAILED`;
const FETCH_ENDED = `${prefix}/FETCH_ENDED`;
const FETCH_SKIPPED = `${prefix}/FETCH_SKIPPED`;

// actions

export const addFavorite = (id) => ({ type: ADD_FAVORITE, payload: id });
export const removeFavorite = (id) => ({ type: REMOVE_FAVORITE, payload: id });

const fetchStart = () => ({ type: FETCH_STARTED });
const fetchEnd = (data) => ({ type: FETCH_ENDED, payload: data });
const fetchFail = (err) => ({ type: FETCH_FAILED, payload: err, error: true });
const fetchSkipped = () => ({ type: FETCH_SKIPPED });

export function fetchDetails() {
  return async (dispatch, getState) => {
    try {
      // get current state and determine missing details
      const currentState = getState();
      const currentListItems = getFavoriteListItems(currentState);
      const currentDetails = getFavoriteListDetails(currentState);
      const missingListItems = currentListItems.filter((id) => !currentDetails.find((o) => o.id === id));

      if (missingListItems.length === 0) {
        return dispatch(fetchSkipped());
      }

      // fetch the missing details
      dispatch(fetchStart());
      const details = await getDetailsBatch(missingListItems);
      const mergedDetails = currentDetails.concat(details);
      dispatch(fetchEnd(mergedDetails));
    } catch (err) {
      dispatch(fetchFail(err));
    }
  };
}

// selectors

const baseSelector = (state) => state.favoriteList;

export const getFavoriteListItems = createSelector(baseSelector, (state) => state.list);

/** @returns {number} */
export const getFavoriteListLength = createSelector(getFavoriteListItems, (list) => list.length);
export const getFavoriteListDetails = createSelector(baseSelector, (state) => state.details);

const initialState = {
  isFetching: false,
  list: [],
  details: [],
};

function favoriteList(state = initialState, action) {
  switch (action.type) {
    case ADD_FAVORITE:
      return {
        ...state,
        list: state.list.find((f) => f === action.payload) ? state.list : state.list.concat([action.payload]),
      };

    case REMOVE_FAVORITE:
      return {
        ...state,
        list: state.list.filter((f) => f !== action.payload),
      };

    case FETCH_STARTED:
      return {
        ...state,
        isFetching: true,
      };

    case FETCH_ENDED:
      return {
        ...state,
        isFetching: false,
        details: action.payload,
      };

    case FETCH_FAILED:
      return {
        ...state,
        isFetching: false,
      };

    case FETCH_SKIPPED:
      return state;

    default:
      return state;
  }
}

const persistConfig = {
  key: "z-catalog-favorite-list",
  storage: storage,
  debug: false,
  whitelist: ["list"],
};

export default persistReducer(persistConfig, favoriteList);
